<div class="reader-container"
     tabindex="0"
     #readerContainer
     [class.page-mode]="readerMode === 'page'"
     [class.scroll-mode]="readerMode === 'scroll'"
     [class.horizontal-mode]="readerMode === 'horizontal'"
     [class.dual-mode]="readerMode === 'dual'"
     [class.dual-cover]="readerMode === 'dual' && dualPageCover">

  @for (page of visiblePages; track page.id) {
    <div class="image-container"
         [style.margin-bottom.px]="readerMode === 'scroll' ? readerGap : 0">

      <img
        #imgRef
        class="reader-img"
        [attr.width]="page.width || null"
        [attr.height]="page.height || null"
        [attr.data-page-id]="page.id"
        [alt]="'page ' + page.id"
      />
    </div>
  }

</div>